// eslint-disable-next-line
export function hasKey<O extends object>(obj: O, key: keyof any): key is keyof O {
    return key in obj
}

/**
 * Type guard to check if a value is an object (but not null)
 * Allows to properly type values
 *
 * @param value - The value to check
 * @returns True if the value is an object, false otherwise
 */
export const isObject = <T extends object>(value: unknown): value is T => value !== null && typeof value === 'object'
